module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    attrs: {
      "data-noteid": _vm.note.id
    }
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('p', {
    staticClass: "note-preview"
  }, [_vm._v(_vm._s(_vm.note.preview))])]), _vm._v(" "), _c('div', {
    staticClass: "right pull-right"
  }, [_c('span', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm.note.date))]), _vm._v(" "), _vm._m(1, false, false)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "checkbox check-warning no-margin"
  }, [_c('input', {
    attrs: {
      "id": "qncheckbox1",
      "type": "checkbox",
      "value": "1"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "qncheckbox1"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#",
      "data-navigate": "view",
      "data-view-port": "#note-views",
      "data-view-animation": "push"
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-right"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19c24cb5"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/note.vue
// module id = 1301
// module chunks = 1